import { isMarketing } from '../marketing/marketingAccessPolicy';
import type { AuthPermissionUser } from '../../services/authPermissions';

/**
 * Handlowiec (sales rep) — technical role ORDER_STAFF.
 *
 * UX mirror of backend/src/utils/salesRepPolicy.js (the backend default-deny
 * API allowlist is the security boundary). The sales rep works only with
 * customers, suppliers, factories, products and his own customer orders, plus
 * personal settings. Every other /app screen redirects to the orders list.
 * Decision: docs/decisions/2026-09-23-handlowiec-role.md.
 */
export const SALES_REP_HOME_PATH = '/app/orders';

const SALES_REP_APP_PATH_PREFIXES = [
  '/app/orders',
  '/app/customers',
  '/app/suppliers',
  '/app/factories',
  '/app/products',
] as const;

// Personal preferences/password only; /app/settings/notifications is excluded.
const SALES_REP_EXACT_APP_PATHS = ['/app/settings'] as const;

export function isSalesRep(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ORDER_STAFF';
}

export function isSalesRepAppPathAllowed(pathname: string): boolean {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if ((SALES_REP_EXACT_APP_PATHS as readonly string[]).includes(path)) {
    return true;
  }
  return SALES_REP_APP_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

/**
 * Internal tasks and the message bodies of the per-order communications log
 * are outside the scope. Who got which e-mail about his own ZK he sees in the
 * card „Aktywność” (the backend drops the bodies for him, 2026-10-05).
 */
export function canUseInternalTasks(user: AuthPermissionUser | null | undefined): boolean {
  return Boolean(user) && !isSalesRep(user) && !isMarketing(user);
}

export function canViewOrderCommunications(user: AuthPermissionUser | null | undefined): boolean {
  return Boolean(user) && !isSalesRep(user) && !isMarketing(user);
}
